import { MergeDataCommon } from "_fil_local_addon/camc-cms-base/index";
import WebsiteChartBase from "./website-fund-chart-base";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class FundNavChart extends WebsiteChartBase {
    constructor(containerId, fundCode) {
        super(containerId, fundCode);
        this.fundCode = fundCode;
        this.containerId = containerId;
        this.chart = null;
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage();
    }

    setEmptyMessage() {
        $("#container-history-c").find(".fil-highcharts-range-selectors").remove();
        if ($("#container-history")) {
            $("#container-history")
                .empty()
                .append("<div>暂无数据显示</div>")
                .css({ display: "flex", "align-items": "center", "justify-content": "center" });
            $(".camc-fund-performance__chart--description#nav-description").remove();
        }
    }

    getApiUrl() {
        return FUND_API_SOURCES.FUND_PERFORMANCE_NAV_SOURCE;
    }

    mergeData(navResData) {
        return this.mergeNavData(navResData);
    }

    createChart({ navDataArray, priceDate }) {
        this.originalNavDataArray = JSON.parse(JSON.stringify(navDataArray));

        if (priceDate) {
            $("#container-updatetime").text("更新日期：" + priceDate);
        }

        const fundName = window.fundName;
        const dateArray = navDataArray.map((item) => [item.x, item.y]);

        if (navDataArray && navDataArray.length > 0) {
            startFundDate = new Date(navDataArray[0]["x"]);
            endFundDate = new Date(navDataArray[navDataArray.length - 1]["x"]);
        }

        let startFundDate = null;
        let endFundDate = null;
        if (dateArray && dateArray.length > 0) {
            startFundDate = new Date(dateArray[0][0]);
            endFundDate = new Date(dateArray[dateArray.length - 1][0]);
        }

        this.startFundDate = startFundDate;
        this.endFundDate = endFundDate;
        this.chartMaxDate = endFundDate;
        this.ytdDiff = endFundDate.getFullYear() > startFundDate.getFullYear() ? 24 * 3600 * 1000 : 0;

        var options = {
            xAxis: {
                showEmpty: false,
                events: {
                    afterSetExtremes: (e) => {
                        if (!e.min || !e.max) return;
                        let min = new Date(e.min);
                        let max = new Date(e.max);
                        min = new Date(min.toISOString().slice(0, 10));
                        max = new Date(max.toISOString().slice(0, 10));
                        chart.xAxis[0].setExtremes(min.getTime(), max.getTime());

                        this.datepickerUpdate(min, max);
                        this.updateRangeButtonStatus();
                    },
                    setExtremes: (e) => {
                        let min = new Date(e.min);
                        let max = new Date(e.max);
                        min = new Date(min.toISOString().slice(0, 10));
                        max = new Date(max.toISOString().slice(0, 10));

                        let navDataArray = JSON.parse(JSON.stringify(this.originalNavDataArray));

                        navDataArray = this.getNavData(navDataArray, min.getTime(), max.getTime());

                        chart.series[0].update(
                            {
                                data: navDataArray,
                            },
                            false,
                        );
                        chart.redraw();

                        this.datepickerUpdate(min, max);
                        this.updateRangeButtonStatus();
                    },
                },
                type: "datetime",
                dateTimeLabelFormats: {
                    day: "%m-%d",
                    week: "%m-%d",
                    month: "%Y-%m",
                    year: "%Y",
                },
            },
            chart: {
                renderTo: this.containerId,
                panning: false, // Disable panning
                type: "spline",
                marginRight: 9,
                marginTop: 0,
                marginLeft: 9,
                spacingBottom: 5,
                reflow: true,

                style: {
                    "font-family": "neuzeit_grotesk, Noto Sans SC, Noto Sans CJK SC, sans-serif !important;",
                },
            },
            series: [
                {
                    turboThreshold: 0,
                    dataGrouping: this.dataGrouping,
                },
            ],
            legend: {
                useHTML: true,
                enabled: true,
                labelFormatter: function () {
                    return '<span title="' + this.name + '">' + this.name + "</span>";
                },
                align: "left",
                itemStyle: {
                    fontSize: "14px",
                    fontWeight: "normal",
                    textOverflow: "unset",
                },
            },

            colors: ["#016FAD", "#FFC000"],
            rangeSelector: {
                selected: 7,
                buttonSpacing: 3,
                buttonTheme: {
                    // styles for the buttons
                    fill: "none",
                    // width: null,
                    // height: 0,
                    style: {
                        color: "#039",
                    },
                    states: {
                        select: {
                            fill: "#016FAD",
                            style: {
                                color: "white",
                                cursor: "default",
                            },
                        },
                        disabled: {
                            fill: "none",
                            style: {
                                cursor: "default",
                            },
                        },
                    },
                },

                inputPosition: {
                    x: -20,
                },
                inputDateFormat: "%Y-%m-%d",
                labelStyle: {
                    color: "black",
                },
                buttons: [
                    {
                        type: "ytd",
                        text: "年初至今",
                        offsetMin: this.ytdDiff,
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3个月",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6个月",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 3,
                        text: "3年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 5,
                        text: "5年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 10,
                        text: "10年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "all",
                        text: "成立至今",
                        offsetMin: 24 * 3600 * 1000,
                    },
                ],
            },

            plotOptions: {
                series: {
                    type: "spline",
                    showInNavigator: false,
                    states: {
                        inactive: {
                            enabled: false,
                        },
                    },
                    events: {
                        legendItemClick: (e) => {
                            e.preventDefault();
                            e.target.setVisible(!e.target.visible);
                            chart.series.some((series) => {
                                if (!series.options.isInternal && series.visible === true) {
                                    this.$rangeSelectors.find("input").prop("disabled", false);
                                    this.initRangeButton(options);
                                    this.updateRangeButtonStatus();
                                    return true;
                                }

                                this.$rangeSelectors.find("input").prop({ disabled: true, checked: false });
                            });
                        },
                    },
                },
            },

            tooltip: {
                useHTML: true,
                formatter: function () {
                    let fundTooltipStr = `
                        <div>
                            <div>
                                <b>
                                    
                                    ${Highcharts.dateFormat("%Y - %m - %d", new Date(this.x))}
                                </b>
                            </div>
                            <div class="fund-name">
                                <span style="color:${this.points[0].series.color}">${this.points[0].series.name}</span>
                                <span>${MergeDataCommon.formatNumber(
                                    this.y,
                                    this.points[0].point.navDecimalPlace,
                                )}</span>
                            </div>
                        </div>
                    `;

                    return fundTooltipStr;
                },
            },
            navigator: {
                xAxis: {
                    dateTimeLabelFormats: {
                        day: "%m-%d",
                        week: "%m-%d",
                        month: "%Y-%m",
                        year: "%Y",
                    },
                },
                series: [
                    {
                        turboThreshold: 0,
                        data: [],
                    },
                ],
            },

            labelStyle: {
                color: "black",
            },
            credits: {
                enabled: false,
            },
        };
        navDataArray = this.getNavData(navDataArray, startFundDate, endFundDate);
        options.series[0].data = navDataArray;
        options.series[0].name = fundName;

        options.navigator.series[0].data = navDataArray;

        Highcharts.setOptions({
            lang: {
                rangeSelectorFrom: "由",
                rangeSelectorTo: "到",
                rangeSelectorZoom: "查看: ",
            },
        });

        let chart = Highcharts.stockChart(this.containerId, options, (chart) => {
            this.datepickerInit("history", startFundDate, endFundDate);
        });

        this.initRangeButton(options);
        this.chart = chart;
        this.updateRangeButtonStatus();
        this.updateRangeButtonPosition(7);
    }
}

export default FundNavChart;
